import QuestionMultChoice from "../components/QuestionMultChoice";
import QuestionTrueFalse from "../components/QuestionTrueFalse";
import QuestionWriteAnswer from "../components/QuestionWriteAnswer";
import QuestionSequence from "../components/QuestionSequence";
import QuestionFillGaps from "../components/QuestionFillGaps";
import QuestionDragDrop from "../components/QuestionDragDrop";
import {Alert, Box} from "@mui/material";

const Test = () => {
    const question = {
        "partner": "Spain-Edensol",
        "number": "14",
        "question_id": "157",
        "category": "Reading and writing",
        "subcategory": "Everyday life to culture",
        "type": "Single choice",
        "description": "new\nline escaped new\\nline",
        "feedback_correct": "WELL DONE!",
        "feedback_incorrect": "Give it another try.",
        "img": "https://i.imgur.com/FPHw86H.jpg",
        "feedback_incorrect2": "The building in picture c) is called la Pedrera or Casa Milá. The characteristics mentioned above that can be seen are mixture of different materials (iron, glass and sandstone) and the curved structures. \r\n\r\nIf the answer is a) This is a cottage house. It is typical in United Kingdom. \r\n\r\nIf the answer is b) This building is called Twin Towers or Petronas Towers and is located in Kuala Lumpur, Malaysia.\r\n\r\nIf the answer is d) This is Petra, a historic and archaeological city in southern Jordan.",
        "answers": [{"content": "a"}, {"content": "b"}]
    }

    const renderQuestion = (question) => {
        if (question === undefined)
            return undefined;
        switch (question["type"]) {
            case "MULT_CHOICE":
                return <QuestionMultChoice question={question}
                                           key={question.id}/>;
            case "Single choice":
                return <QuestionMultChoice question={question}
                                           key={question.id}/>;
            case "TRUE_FALSE":
                return <QuestionTrueFalse question={question}
                                          key={question.id}/>;
            case "WRITE_ANSWER":
                return <QuestionWriteAnswer question={question}
                                            fkey={question.id}/>;
            case "SEQUENCE":
                return <QuestionSequence question={question}
                                         key={question.id}/>;
            case "FILL_GAPS":
                return <QuestionFillGaps question={question}
                                         key={question.id}/>;
            case "DRAG_DROP":
                return <QuestionDragDrop question={question}
                                         key={question.id}/>;
            default:
                return <Alert severity="error">Invalid question type: {question["type"]}</Alert>;
        }
    }

    return (
        <Box>
            {renderQuestion(question)}
        </Box>
    );
}

export default Test;